import type {
  NotificationKey,
  SettingsGetPayload,
  useGetSettingsOptions,
} from "./settings.type";
import type { ApiError } from "@/services/api";

import { useQuery } from "@tanstack/react-query";

import { client } from "@/config/client";
import { useAppLocale } from "@/services/language";

import { CURRENT_USER_SETTINGS_QUERY_KEY } from "./settings.constant";

export const useGetSettings = (options?: useGetSettingsOptions) => {
  const { data, ...queryResult } = useQuery<SettingsGetPayload, ApiError>({
    queryKey: CURRENT_USER_SETTINGS_QUERY_KEY,
    queryFn: () => client.settings.get(),
    staleTime: Infinity,
    ...options,
  });

  return {
    settings: data?.data?.data,
    ...queryResult,
  };
};

export const useGetSettingsLocale = () => {
  const { settings } = useGetSettings();
  const appLocale = useAppLocale();

  return settings?.locale ?? appLocale;
};

export const useGetSettingsNotifications = () => {
  const { settings, ...queryResult } = useGetSettings();

  const notifications = settings?.notifications;

  const isBroadcastNotificationEnabled = (key: NotificationKey) => {
    return !!notifications?.[key]?.["broadcast"];
  };

  return {
    userPreferencesNotifications: notifications,
    isBroadcastNotificationEnabled,
    ...queryResult,
  };
};
